import * as React from 'react';
import { getStatisticCenterMatchURL } from '../../api/assetUrls';
import('./StatsControlsStyles.scss')   

/*
	This component consists of statistic control buttons.
*/
const StatsControlsPresentation = ( props: { direction: 'horizontal'|'vertical', visible: boolean, statisticCenterBaseUrl: string, seasonid: number, matchid: number, lang: string, s5Alias: string, overlayToggle: () => void } ) => {
  return (
    <div className={"statisticsControl overlayStatisticCenterControlsContainer " + (props.direction)}>
      <div className="statisticsControlButtonWrapper" >
        <div
          className={"statisticsControlButton statisticsOverlayButton " + (isActive(props.visible))}
          onClick={(event) => {
            props.overlayToggle();
          }}>
        </div>
        <a className="statisticsControlButton statisticCenterButton" href={getStatisticCenterMatchURL(props.statisticCenterBaseUrl, props.seasonid, props.matchid, props.lang, props.s5Alias)} target="SRVG Statistics Center" onClick={matomoTrackingClickEvent}></a>
	    </div>
  	</div>
  )
}

// returns a strict active if the boolean is true
const isActive = (active : boolean) => active ? 'active' : ''

const matomoTrackingClickEvent = () => {
  const srvg = (window as any).srvg;
  srvg.Matomo.push(['trackEvent', 'VTI_Statistics_Center', 'open']);
};

export default StatsControlsPresentation